import { BoxProps, ColorOptions, required } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { Dropdown } from '../../components/Dropdown'
import { WrapperText } from '../../components/WrapperText'

export const typeData = [
  { id: 1, value: 'BANK' },
  { id: 2, value: 'AGGREGATOR' },
]
export const subtypeData = [
  { id: 1, value: 'ONLINE' },
  { id: 2, value: 'OFFLINE' },
]
export const statusData = [
  { id: 1, value: 'ACTIVE' },
  { id: 2, value: 'INACTIVE' },
]
export const netBankingData = [
  { id: 1, value: 'NOT_SUPPORTED' },
  { id: 2, value: 'SUPPORTED' },
]
export const cardData = [
  { id: 1, value: 'NOT_SUPPORTED' },
  { id: 2, value: 'REDIRECT' },
  { id: 3, value: 'THREE_LEG' },
]
const checksumData = [
  { id: 1, value: 'NOT_SUPPORTED' },
  { id: 2, value: 'CHECKSUM' },
  { id: 3, value: 'ENCRYPTION' },
]

const contactData = [
  { id: '1', value: 'MANAGER' },
  { id: '2', value: 'TECHNICAL' },
  { id: '3', value: 'PRODUCT' },
  { id: '4', value: 'OTHER' },
]

const textinputStyle = {
  type: 'body14',
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  selectionColor: 'BLUE',
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}

const dividerStyles = {
  borderColor: '#d1d3e2' as ColorOptions,
  borderTopWidth: 1,
  pv: 8,
} as BoxProps

const getVisibility = (data: any, label?: string) => {
  if (!data) {
    return false
  }
  if (!label) {
    return true
  }
  const keys: Array<any> = []
  data.map((item: any) => {
    const key = Object.keys(item)[0]
    keys.push(key.replaceAll(' ', '').toLowerCase())
  })

  if (keys.indexOf(label.toLowerCase()) > -1) {
    return false
  }
  return true
}
export const formData: any = (
  goBack: () => void,
  addEntity: (data: any) => void,
  id: string | undefined,
  updateEntity: (values: any) => void,
  message: string,
  selectedFields?: any,
) => {
  return selectedFields?.length > 0
    ? [
        {
          key: 'entityInfo',
          verticalSpacing: 4,
          formItems: [
            {
              horizontalComps: [
                {
                  fieldName: 'name',
                  ComponentName: TextInputNew,
                  placeholder: 'Processor Name',
                  label: 'Name*',
                  validationSchema: required,
                  hide: getVisibility(selectedFields, 'Name'),
                  ...textinputStyle,
                },
                {
                  fieldName: 'type',
                  ComponentName: Dropdown,
                  minWidth: 150,
                  label: 'Type*',
                  title: 'Type',
                  validationSchema: required,
                  hide: getVisibility(selectedFields, 'Type'),
                  data: typeData,
                },
                {
                  fieldName: 'subType',
                  ComponentName: Dropdown,
                  minWidth: 150,
                  label: 'SubType*',
                  title: 'SubType',
                  validationSchema: required,
                  hide: getVisibility(selectedFields, 'subType'),
                  data: subtypeData,
                },
                {
                  fieldName: 'status',
                  ComponentName: Dropdown,
                  minWidth: 150,
                  title: 'Status',
                  label: 'Status*',
                  validationSchema: required,
                  hide: getVisibility(selectedFields, 'Status'),
                  data: statusData,
                },
              ],
            },
            {
              fieldName: 'message',
              ComponentName: WrapperText,
              title: message,
              color: 'ERROR',
              hide: message === '',
            },
          ],
          verticalSpacing: 8,
          onSubmit: async (values: any) => {
            updateEntity(values)
            return 'end'
          },
          actionTitle: 'Update',
        },
      ]
    : [
        {
          key: 'entityInfo',
          verticalSpacing: 4,
          formItems: [
            {
              horizontalComps: [
                {
                  fieldName: 'id',
                  ComponentName: TextInputNew,
                  placeholder: 'Processor Id',
                  label: 'Processor Id*',
                  validationSchema: required,
                  ...textinputStyle,
                },
                {
                  fieldName: 'name',
                  ComponentName: TextInputNew,
                  placeholder: 'Processor Name',
                  label: 'Name*',
                  testID: 'entity-name-input',
                  accessibilityLabel: 'entity-name-input',
                  validationSchema: required,
                  ...textinputStyle,
                },
              ],
            },

            {
              horizontalComps: [
                {
                  fieldName: 'type',
                  ComponentName: Dropdown,
                  label: 'Type*',
                  title: 'Type',
                  validationSchema: required,
                  testID: 'entity-type-dropdown',
                  accessibilityLabel: 'entity-type-dropdown',
                  data: typeData,
                },
                {
                  fieldName: 'subType',
                  ComponentName: Dropdown,
                  minWidth: 150,
                  label: 'SubType*',
                  title: 'SubType',
                  validationSchema: required,
                  hide: getVisibility(selectedFields, 'subType'),
                  data: subtypeData,
                },
                {
                  fieldName: 'entityStatus',
                  ComponentName: Dropdown,
                  title: 'Status',
                  label: 'Status*',
                  testID: 'status-dropdown',
                  validationSchema: required,
                  data: statusData,
                },
              ],
            },
            {
              horizontalComps: [
                {
                  fieldName: 'metadata',
                  ComponentName: TextInputNew,
                  placeholder: 'MetaData',
                  label: 'MetaData',
                  ...textinputStyle,
                },
              ],
            },
          ],
          horizontalFlex: 1,
          onSubmit: async (values: any) => {
            addEntity(values)
            return 'end'
          },
          actionTitle: 'Add Processor',
        },
      ]
}
